import React from 'react';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/system';
import DashboardIcon from '@mui/icons-material/Dashboard';
import AssessmentIcon from '@mui/icons-material/Assessment';
import ArticleIcon from '@mui/icons-material/Article';
import LogoutIcon from '@mui/icons-material/Logout';
import { useNavigate } from 'react-router-dom';
import { auth } from '../../firebase';
import { signOut, setPersistence, browserLocalPersistence } from 'firebase/auth'; // import setPersistence and browserLocalPersistence

const GenerateButton = styled('button')({
    display: 'flex',
    alignItems: 'flex-start',
    backgroundColor: 'transparent',
    padding: '15px',
    paddingLeft: '25%',
    borderRadius: '0px 10px 10px 0px',
    fontWeight: 500,
    fontFamily: 'Poppins, sans-serif',
    width: '85%',
    borderColor: 'transparent',
    fontSize: '16px',
    color: '#7A879B',
    cursor: 'pointer',
    '&.ChangeButton': {
        backgroundColor: '#2560CD',
        color: 'white',
    },
});

const GenerateButton2 = styled('button')({
    display: 'flex',
    alignItems: 'flex-start',
    backgroundColor: 'transparent',
    padding: '15px',
    paddingLeft: '25%',
    cursor: 'pointer',
    borderRadius: '0px 10px 10px 0px',
    fontWeight: 500,
    fontFamily: 'Poppins, sans-serif',
    width: '85%',
    borderColor: 'transparent',
    fontSize: '16px',
    color: '#7A879B',
    transition: 'background-color 0.3s, color 0.3s',

    '&:hover': {
        backgroundColor: '#2560CD',
        color: 'white',
    },

    '&.ChangeButton': {
        backgroundColor: '#2560CD',
        color: 'white',
    },
});

const NavBar = ({ activePage, user }) => {
    const navigate = useNavigate();
    const [isButtonClicked, setIsButtonClicked] = React.useState(0);

    const handleButtonClick = (index) => {
        if (index === 4) {
            // Set persistence to browserLocalPersistence before signing out
            setPersistence(auth, browserLocalPersistence)
                .then(() => {
                    // Sign out after setting persistence
                    return signOut(auth);
                })
                .then(() => {
                    // After sign out, navigate to the home page
                    setIsButtonClicked(index);
                    navigate('/');
                })
                .catch((error) => {
                    // Handle any errors during persistence setting or sign out
                    console.error('Error during sign out:', error);
                });
            return;
        }
    };

    const navigationButtons = [
        { icon: <DashboardIcon />, text: 'Dashboard\t' },
        { icon: <AssessmentIcon />, text: 'Assessment' },
        { icon: <ArticleIcon />, text: `Report` },
    ];

    return (
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%' }}>
            <div>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '15px' }}>
                    <Typography style={{
                        fontFamily: 'Poppins, sans-serif',
                        padding: '10px',
                        fontWeight: 600,
                        fontSize: '30px',
                        marginBottom: '15px'
                    }} >
                        Vocation<span style={{ color: 'red' }}>IQ</span>
                    </Typography>
                </div>
                {navigationButtons.map((button, index) => (
                    <div style={{ marginBottom: 10 }} key={index}>
                        <GenerateButton
                            className={activePage === index ? 'ChangeButton' : ''}
                            onClick={() => handleButtonClick(index)}
                        >
                            {button.icon}
                            <Typography style={{
                                marginLeft: '10px', fontFamily: 'Poppins, sans-serif',
                                fontWeight: 500,
                                fontSize: '16px',
                            }}>
                                {button.text}
                            </Typography>
                        </GenerateButton>
                    </div>
                ))}
            </div>
            <div>
                <GenerateButton2
                    className={isButtonClicked === 4 ? 'ChangeButton' : ''}
                    onClick={() => handleButtonClick(4)}
                >
                    <LogoutIcon />
                    <Typography style={{
                        marginLeft: '5px', fontFamily: 'Poppins, sans-serif',
                        fontWeight: 500,
                        fontSize: '16px',
                    }}>
                        Logout
                    </Typography>
                </GenerateButton2>
            </div>
        </div>
    )
}

export default NavBar;
